import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeEaState } from '@store/actions/eaAction';

import HealthCarePopup from '@components/ea/HealthCarePopup';

const HealthCareMain = props => {
  const {
    planMainInfo,
    contractSign,
    searchPasteSignData,
    signPasteData,
    complete,
    searchSignData,
    signData,
    onSave,
    isPracticeMode,
    practiceSignName,
    practiceSignature,
  } = props;

  const [pasteCheck, setPasteCheck] = useState(false); // 붙여넣기 체크 여부
  const [pasteCheck2, setPasteCheck2] = useState(false); // 붙여넣기 체크 여부
  const [isFollowTxtError, setIsFollowTxtError] = useState(false);
  const [signNameData, setSignNameData] = useState(''); // 성명
  const [signatureData, setSignatureData] = useState(''); // 서명
  const [signNameData2, setSignNameData2] = useState(''); // 성명
  const [signatureData2, setSignatureData2] = useState(''); // 서명
  const [isValid, setIsValid] = useState(false);

  const dispatch = useDispatch();

  // 리듀서값 변경
  const handleInputChange = (target, value) => {
    const changeData = contractSign.map(data => {
      if (data.step === 527) {
        //수집·이용 동의여부
        if(target.includes('q1')){
          if(value === '1'){
            //헬스케어 서비스 서명란 사용여부
            $("#healthService").hide();
            return { ...data, q1: value , q2: value};
          }else{
            if(data.q2 === '1'){
              $("#healthService").hide();
            }else{
              $("#healthService").show();
            }
            return { ...data, q1: value};
          }
        }else{
          //정보제공 동의여부
          if(data.q1 === '1'){
            //헬스케어 서비스 서명란 사용여부
            $("#healthService").hide();
            return { ...data, q2: '1'};
          }else{
            if(value === '1'){
              $("#healthService").hide();
            }else{
              $("#healthService").show();
            }
            return { ...data, q2: value};
          }
        }
      } else {
        return data;
      }
    });
    dispatch(changeEaState({ type: 'contractSign', data: changeData }));
  };

  // 붙여넣기 서명 조회
  const handlePasteCheck = (target, value) => {
    if (value && !isPracticeMode) {
      searchPasteSignData();
    }
    if(target.includes('s1')){
      setPasteCheck(value);
    }else{
      setPasteCheck2(value);
    } 
    
  };

  // 확인버튼 valid 체크
  const isValidCheck = () => {
    const healthData = contractSign.filter(data => data.step === 527)[0];
    if (healthData.q1 === '') return setIsFollowTxtError(true);
    if (healthData.q2 === '') return setIsFollowTxtError(true);
    if (healthData.q2 === '0'){
      if (signNameData2 === '' || signatureData2 === '') return setIsFollowTxtError(true);
    }
    if (signNameData === '' || signatureData === '')
      return setIsFollowTxtError(true);
    setIsFollowTxtError(false);
    onSave({
      signNameData: signNameData,
      signatureData: signatureData,
      reportId: 'app_form_etc_27',
      signId: 'app_form_etc_27_signid_02',
      nameId: 'app_form_etc_27_signid_01',
    });
    if (healthData.q2 === '0'){
      onSave({
        signNameData: signNameData2,
        signatureData: signatureData2,
        reportId: 'app_form_etc_27',
        signId: 'app_form_etc_27_signid_04',
        nameId: 'app_form_etc_27_signid_03',
      });
    }
  };

  // 완료된 페이지의 경우 기존 저장된 서명데이터 조회
  useEffect(() => {
    if (
      complete &&
      (!signData.app_form_etc_27_signid_01 ||
        !signData.app_form_etc_27_signid_02)
    ) {
      !isPracticeMode &&
        searchSignData(
          'app_form_etc_27',
          `app_form_etc_27_signid_01`,
          `app_form_etc_27_signid_02`,
        );
    }
  }, [complete]);

  useEffect(() => {
    if (
      complete &&
      (!signData.app_form_etc_27_signid_03 ||
        !signData.app_form_etc_27_signid_04)
    ) {
      !isPracticeMode &&
        searchSignData(
          'app_form_etc_27',
          `app_form_etc_27_signid_03`,
          `app_form_etc_27_signid_04`,
        );
    }
  }, [complete]);

  useEffect(() => {
    const healthData = contractSign.filter(data => data.step === 527)[0];
    if (
      complete &&
      (healthData.q2 === '1')
    ) {
      !isPracticeMode &&
      $("#healthService").hide();
    }
  }, [complete]);
  
  
  // 버튼 validation 상태 변경
  useEffect(() => {
    const healthData = contractSign.filter(data => data.step === 527)[0];
    if (healthData.q1 === '') return setIsValid(false);
    if (healthData.q2 === '') return setIsValid(false);
    if (healthData.q2 === '0'){
      if (signNameData2 === '' || signatureData2 === '') return setIsValid(false);
    }
    if (signNameData === '' || signatureData === '') return setIsValid(false);
    return setIsValid(true);
  }, [contractSign, signNameData, signatureData, signNameData2, signatureData2]);

  return (
    <HealthCarePopup
      health={contractSign.filter(data => data.step === 527)[0]}
      onChange={handleInputChange}
      pasteCheck={pasteCheck}
      pasteCheck2={pasteCheck2}
      onClickPasteCheck={handlePasteCheck}
      isFollowTxtError={isFollowTxtError}
      signNameData={signNameData}
      signNameData2={signNameData2}
      signatureData={signatureData}
      signatureData2={signatureData2}
      name={planMainInfo.insuredPrspInfo.name}
      signPasteData={signPasteData}
      complete={complete}
      signData={signData}
      setSignNameData={setSignNameData}
      setSignNameData2={setSignNameData2}
      setPasteCheck={setPasteCheck}
      setPasteCheck2={setPasteCheck2}
      setSignatureData={setSignatureData}
      setSignatureData2={setSignatureData2}
      isValid={isValid}
      isValidCheck={isValidCheck}
      isPracticeMode={isPracticeMode}
      practiceSignName={practiceSignName}
      practiceSignature={practiceSignature}
    />
  );
};

export default HealthCareMain;
